var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGradientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 1.33337C4.3187 1.33337 1.33203 4.32004 1.33203 8.00004C1.33203 11.68 4.3187 14.6667 7.9987 14.6667C11.6787 14.6667 14.6654 11.68 14.6654 8.00004C14.6654 4.32004 11.6787 1.33337 7.9987 1.33337ZM7.33203 11.3334V7.33337H8.66536V11.3334H7.33203ZM7.33203 4.66671V6.00004H8.66536V4.66671H7.33203Z",
    fill: "url(#paint0_linear_5675_10330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5675_10330",
    x1: 1.33203,
    y1: 8.00004,
    x2: 14.6654,
    y2: 8.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6145"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGradientIcon);
export default __webpack_public_path__ + "static/media/info-gradient-icon.35f628c3dd62dbe236b9204e66e6641b.svg";
export { ForwardRef as ReactComponent };